// create enum for currencies
export enum Currency {
  MNDE = "MNDE",
  MPLX = "MPLX",
  SWTCH = "SWTCH",
  SOL = "SOL",
  DRVS = "DRVS",
  USDC = "USDC",
  ZRC = "ZRC",
}
